import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

interface LoginFormProps {
  onSwitchToTotp: (adminId: string) => void;
  onSwitchToOtp: (username: string) => void;
  onSuccess?: () => void;
}

export function LoginForm({ onSwitchToTotp, onSwitchToOtp, onSuccess }: LoginFormProps) {
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      const result = await login(username, password);
      if (result.requiresTotp && result.adminId) {
        onSwitchToTotp(result.adminId);
      } else if (!result.requiresTotp && onSuccess) {
        onSuccess();
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3 className="card-title">{t('forms.auth.login.title', 'Password Login')}</h3>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="mb-3">
        <label htmlFor="username" className="form-label">{t('auth.username')}</label>
        <input
          type="text"
          className="form-control"
          id="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          minLength={1}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="password" className="form-label">{t('auth.password')}</label>
        <input
          type="password"
          className="form-control"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={12}
        />
      </div>

      <button type="submit" className="btn btn-primary w-100">
        {t('auth.sign_in')}
      </button>

      <div className="mt-3 text-center">
        <button
          type="button"
          className="btn btn-link"
          onClick={() => onSwitchToOtp(username)}
        >
          {t('auth.use_otp_instead')}
        </button>
      </div>
    </form>
  );
}
